import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721dd5a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base feedback-container" }
const _hoisted_2 = { class: "footer-setting" }

import { ref } from 'vue'
import useSpaceApi from '@/composables/api/useSpaceApi'
import useAuth from '@/composables/api/useAuth'

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackClassButton',
  props: {
  exitPath: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props
const { saveLogsLeaveButton } = useSpaceApi()
const { getAccessInfo } = useAuth()
const isOpenedPopup = ref(false)
const feedback = async () => {
  const { roomId, participantId } = getAccessInfo()
  isOpenedPopup.value = false
  await saveLogsLeaveButton(roomId || '', participantId || '')
  window.location.href = props.exitPath
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Popup, {
      title: `${_ctx.$t('feedback')}`,
      open: isOpenedPopup.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isOpenedPopup.value = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: feedback
          }, _toDisplayString(_ctx.$t('confirm-btn')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-tertiary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpenedPopup.value = false))
          }, _toDisplayString(_ctx.$t('cancel-btn')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('feedback-message', { exitPath: __props.exitPath })), 1)
      ]),
      _: 1
    }, 8, ["title", "open"]),
    _createElementVNode("button", {
      class: "btn-action-nav nav-menu-item",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (isOpenedPopup.value = true))
    }, [
      _createVNode(_component_SvgIcon, {
        class: "_pointer-on-hover mr-1",
        icon: "required",
        "inherit-fill": true,
        height: "26"
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('feedback-button')), 1)
    ])
  ]))
}
}

})